import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
export function MobileStickyCTA() {
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    delay: 1
  }} className="md:hidden fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 pt-3 bg-gradient-to-t from-dark via-dark/95 to-transparent" style={{
    paddingBottom: 'max(1rem, env(safe-area-inset-bottom))'
  }} data-id="element-217" data-mp="2npxhnayva3yr">
      <a href="tel:9548710290" className="flex items-center justify-center w-full px-6 py-4 text-lg font-bold rounded-xl text-white bg-orange shadow-2xl shadow-orange/40 active:scale-[0.98] transition-transform" aria-label="Call Palm Beach Powerstroke at 954-871-0290" data-id="element-218" data-mp="36lnll3qd1afa">
        <Phone className="w-5 h-5 mr-3" data-id="element-219" data-mp="3kdk90uh32w5c" />
        Call Now: 954-871-0290
      </a>
    </motion.div>;
}